import { PUT_PRESUPUESTO, FACTURADO, COBRADO } from "../actions/actionPresupuesto";

const initialState = {    
    putPresupuesto: {},
    facturado: {},
    cobrado: {}

}

export default function reducerPresupuesto(state = initialState, action){
    switch (action.type) {        
        case PUT_PRESUPUESTO:
            return {
                ...state,
                putPresupuesto: action.payload
            }
        case FACTURADO:
            return {
                ...state,
                facturado: action.payload
            }
        case COBRADO:
            return {
                ...state,
                cobrado: action.payload
            }         
        default:
            return {...state};
    }
}